<template>
  <v-sheet class="grey lighten-1">
    <component :is="component" class="py-8 py-md-10 pb-10 pb-lg-16">
      <TitleWidget v-if="title" class="mb-8">{{ title }}</TitleWidget>

      <LoadingWidget v-if="loading" />

      <template v-else>
        <slot />
      </template>
    </component>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import { VContainer } from "vuetify/lib/components";

export default {
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    component() {
      return this.container ? "v-container" : "div";
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    VContainer,
  },
};
</script>
